(ns machtfit.url-params
  (:require [clojure.edn :as edn]
            [clojure.set :as set]
            [clojure.string :as str]))

(defn- query-params->edn [{:keys [q]}]
  ;; a URL "...?q" will result in the string "null" being the value of
  ;; query-params as delivered by secretary. Handle this as `nil`.
  (if (= "null" q)
    nil
    ;; gracefully handle stuff in the query string that is not edn
    (try
      (edn/read-string q)
      (catch :default _
        nil))))

(defn- url-data->filter [{:keys [distance] :as url-data}]
  (let [data (select-keys url-data
                          [;; sets
                           :categories
                           :labels
                           :product-types
                           ;; booleans
                           :apps?
                           :estg3no34-subsidizable?
                           :favorites
                           :free-of-charge?
                           :mf-offer
                           :no-schedule
                           :online
                           :open?
                           :promotions
                           :streams
                           :subsidy
                           :show-map
                           ;; keyword-sets
                           :age
                           :weekdays
                           :gender
                           :starts-after
                           :starts-before
                           ;; keywords
                           :sort-by
                           :area
                           ;; int
                           :price-min
                           :price-max
                           ;; strs
                           :keyword])]

    (cond-> data
      (<= 1 distance 70) (assoc :distance distance))))

(defn url-param->boolean [value]
  (= (str/lower-case value) "true"))

(defn url-param->keyword [value]
  (keyword value))

(defn url-param->keyword-set [value]
  (if (coll? value)
    #{(keyword value)}
    (set (map keyword value))))

(defn url-param->int-set [value]
  (if (coll? value)
    (set (map int value))
    #{(int value)}))

(defn url-param->area [value]
  (case value
    "machtfit" :machtfit
    "company" :company
    :all))

(defn url-param->set [value]
  (if (coll? value) (set value) #{value}))

(def url-params-types
  {:categories url-param->set
   :labels url-param->set
   :product-types url-param->set

   :age url-param->keyword-set
   :gender url-param->keyword-set

   :weekdays url-param->int-set

   :distance int
   :price-min int
   :price-max int

   :apps? url-param->boolean
   :estg3no34-subsidizable url-param->boolean
   :favorites url-param->boolean
   :free-of-charge? url-param->boolean
   :mf-offer url-param->boolean
   :no-schedule url-param->boolean
   :online url-param->boolean
   :open? url-param->boolean
   :promotions url-param->boolean
   :streams url-param->boolean
   :subsidy url-param->boolean
   :show-map url-param->boolean

   :sort-by url-param->keyword

   :area url-param->area})

(def url-param-names
  {:apps? :apps
   :free-of-charge? :free-of-charge
   :open? :open?
   :estg3no34-subsidizable? :estg3no34-subsidizable})

(defn converter [url-data]
  (set/rename-keys
   (into {}
         (map
          (fn [[k v]]
            (let [convert-fn (get url-params-types k identity)]
              [k (try
                   (convert-fn v)
                   (catch :default _
                     nil))])))
         url-data)
   (set/map-invert url-param-names)))

(defn query-params->filter [query-params]
  (url-data->filter
   (or (query-params->edn query-params)
       (converter query-params))))
